//Joyride steps for the first-time Users


export  const TemplateCarouselStep = [
  {
    target: '.credits',
    content: (
      <div>
        You have <strong>2 credits</strong> available for use.
      </div>
    ),
  },
    {
      target: '.template-card',
      content: (
        <div>
          <strong>Step 1:</strong> Select a template to continue with.
          <br />
          (New templates coming soon! 😅)
        </div>
      ),
    }] 


export const Template1Steps = [
    {
      target: '.basic_details_count',
      content: (
        <div>
          <strong>Step 2:</strong> Specify how many questions you'd like in your worksheet. <br />
        </div>
      ),
    },
    {
      target: '.region-switch',
      content: (
        <div>
               <strong>Step 3:</strong> Select your region (UK or US). <br />
      This ensures the curriculum and year groups are tailored to the chosen country.
    </div>
      ),
    },
    {
      target: '.yeargroup-dropdown',
      content: (
        <div>
          <strong>Step 4:</strong> Choose the year group for which the questions will be generated. <br />
          This helps us match the content to the correct skill level.
        </div>
      ),
    },
    {
      target: '.difficulty-dropdown',
      content: (
        <div>
          <strong>Step 5:</strong> Set the difficulty level. <br />
          Whether your students are beginners or experts, we’ve got you covered.
        </div>
      ),
    },
    {
      target: '.add-lessons-button',
      content: (
        <div>
          <strong>Step 6:</strong> Browse our extensive library to choose the relevant lesson. <br />
          Don’t see a lesson you need? Use the CUSTOM LESSONS✨ tab to add!
        </div>
      ),
    },
    {
      target: '.generate-button',
      content: (
        <div>
          <strong>Step 7:</strong> Click here to generate your questions! 🎉
        </div>
      ),
    },
    {
      target: '.download_pdf_button',
      content: (
        <div>
          <strong>Step 8:</strong> Click here to download ⬇️ a PDF of the worksheet above! 
        </div>
      ),
    },
  ];

// export  const Template2Steps = [
//     {
//       target: '.operation-buttons-div',
//       content: (
//         <div>
//           <strong>Step 2:</strong> Select the type of operation for the questions.
//         </div>
//       ),
//     },
//     {
//       target: '#first-number',
//       content: (
//         <div>
//           <strong>Step 3:</strong> Specify the number of digits for the first number in the column <br />
//           <em>Maximum: 6 digits</em> (e.g., up to 4 digits for thousands)
//         </div>
//       ),
//     },
//     {
//       target: '#second-number',
//       content: (
//         <div>
//           <strong>Step 4:</strong> Specify the number of digits for the second number in the column <br />
//           <em>Maximum: 6 digits</em> (e.g., up to 3 digits for hundreds)
//         </div>
//       ),
//     }
//     ,
//     {
//       target: '.generate-button',
//       content: (
//         <div>
//           <strong>Step 5:</strong> Click here to generate your custom worksheet and download it as a PDF! 🎉
//         </div>
//       ),
//     }
//     ]




